import Icon from '../components/Icon.vue'

Icon.register({
  sign: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-368v368c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-368h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h368zM160 384v-224h320v224h-320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sign.js
// module id = 1890
// module chunks = 0